import {ReactNode} from "@tanstack/react-router";
import {ButtonHTMLAttributes} from "react";
import {RowVariants, row} from "./index.css";

type RowProps = {children: ReactNode | ReactNode[]} & ButtonHTMLAttributes<HTMLDivElement> & RowVariants;

function Row({fullWidth, children, className, ...rest}: RowProps) {
	return (
		<section className={`${row({fullWidth})} ${className}`} {...rest}>
			{children}
		</section>
	);
}

export default Row;
